import type { FrontendWidget } from '../types';
import { TickerComponent } from './TickerComponent';
import { TickerComponentB } from './TickerComponentB';
import { TickerComponentC } from './TickerComponentC';
import type { TickerConfig, TickerResolved } from './types';

export const tickerWidget: FrontendWidget<TickerConfig, TickerResolved> = {
  componentType: 'widgets.ticker',
  // 70.14: SlotRenderer adds no container — full-bleed: `max-lg:fixed` takes it out of normal flow entirely.
  layout: 'self',
  displayName: 'Ticker',
  defaultValues: { message: '' },
  ComponentA: TickerComponent,
  ComponentB: TickerComponentB,
  ComponentC: TickerComponentC,
  // No `resolveSync` — a lookup widget since SH-344 item 2.14. What the ticker
  // says, and whether it renders at all, now depends on the Standort's
  // `LocationCustomization`, which only the backend can read. `TickerResolver`
  // passes the template's own config through byte-for-byte on every page that
  // has no Standort, so nothing outside a Standort page changes.
};
